import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ObjectCreatorService } from 'src/app/core/services/object-creator.service';

@Component({
  selector: 'app-object-card-placeholder',
  templateUrl: './object-card-placeholder.component.html',
  styleUrl: './object-card-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ObjectCardPlaceholderComponent {
  @Input() type: string;
  @Input() action: () => void;

  constructor(private objectCreatorService: ObjectCreatorService) {}

  handleClick() {
    switch (this.type) {
      case 'workspace':
        this.objectCreatorService.createNewWorkspace();
        break;
      case 'feed':
        this.objectCreatorService.createNewFeed();
        break;
      case 'dashboard':
        this.objectCreatorService.createNewDashboard();
        break;
      case 'dimension':
        this.objectCreatorService.createNewDimension();
        break;
      case 'alert':
      case 'schedule':
        this.action?.();
        break;
      default:
        console.error('Invalid object type');
        break;
    }
  }
}
